import IconTriangleDownArrow from "ui/icons/IconTriangleDownArrow";

export default function CaretExpander({ isExpanded, size }: { isExpanded: boolean; size: number }) {
  return <IconTriangleDownArrow size={size} rotate={isExpanded ? 0 : -90} />;
}
